// ──────────────────────────────────────────────
// React hooks for RecordingService.
// Use useSyncExternalStore for tear-free reads.
// ──────────────────────────────────────────────

import { useSyncExternalStore } from 'react';

import type { RecordingService } from './RecordingService';
import type { RecordingState } from './types';

// ── Fallback snapshot (returned when service is null) ──

const IDLE_RECORDING: RecordingState = {
  status: 'idle',
  duration: 0,
  chunkCount: 0,
  activeDeviceId: null,
  mimeType: null,
  initSegmentCaptured: false,
  error: null,
  mixerSuspended: false,
  micMuted: false,
};

const noop = () => () => {};

/**
 * Subscribe to RecordingService state.
 * Returns a static idle state when service is null.
 */
export function useRecordingState(service: RecordingService | null): RecordingState {
  return useSyncExternalStore(
    service ? (cb) => service.subscribe(cb) : noop,
    service ? () => service.getSnapshot() : () => IDLE_RECORDING,
  );
}
